"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPreviewAssignment = void 0;
const pins_shared_1 = require("@lessonup/pins-shared");
const AppError_1 = require("../errors/AppError");
const AssignmentComplete_1 = require("./AssignmentComplete");
function createPreviewAssignment({ lessonData }) {
    const { lesson, pins } = lessonData;
    if (!lessonData || !pins.length) {
        throw new AppError_1.AppError('invalid-params', 'lessonData is not valid', {
            lessonId: lesson._id,
        });
    }
    const options = {
        subject: undefined,
        groupId: undefined,
        origin: 'link',
        message: undefined,
        language: undefined,
        label: undefined,
        legacy: true,
        module: undefined,
        order: undefined,
    };
    const assignmentId = (0, pins_shared_1.randomId)();
    const pincode = '111-111';
    const preferredPin = pins[0];
    const ownerId = (0, pins_shared_1.randomId)();
    const assignment = AssignmentComplete_1.AssignmentComplete.createRealtimeAssignment(assignmentId, pincode, lessonData, preferredPin, options, ownerId, false, false, true, false, false, true);
    return assignment;
}
exports.createPreviewAssignment = createPreviewAssignment;
//# sourceMappingURL=create-preview-assignment.js.map